import { GenericMachine } from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { validateBigDataQuestionApi as API } from '../Apis';

export const ValidateBigDataQuestionDocs: IDocs = {
  title: 'ValidateBigDataQuestion',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.AccountServices.validateBigDataQuestion',
};

const prepareCall = (stateRequestParameters: any) =>
  API.call.post({
    ticketId: stateRequestParameters.ticketId,
    answers: stateRequestParameters.answers,
  });

export const ValidateBigDataQuestionMachine = GenericMachine(prepareCall, {
  docs: ValidateBigDataQuestionDocs,
  definitions: API.definitions,
});
